import React from 'react';
import ToolsList from './ToolsList';

const ToolsSection = ({
  tools,
  onEdit,
  onDelete,
  isAdmin,
  deletingToolName,
  isFiltered,
  onClearFilter,
}) => {
  return (
    <section className="tools-section">

      <ToolsList
        tools={tools}
        onEdit={onEdit}
        onDelete={onDelete}
        isAdmin={isAdmin}
        deletingToolName={deletingToolName}
        isFiltered={isFiltered}
        onClearFilter={onClearFilter}
      />
    </section>
  );
};

export default ToolsSection;
